import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle, Facebook, Linkedin, Instagram, Youtube } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { waLink, quoteMessage } from "@/lib/whatsapp";

export default function Footer() {
  const { settings } = useSettings();
  const [legal, setLegal] = useState({});
  useEffect(()=>{Promise.all(["terms","privacy"].map(page=>fetch(`/api/legal/${page}`).then(r=>r.ok?r.json():null))).then(([terms,privacy])=>setLegal({terms,privacy}));},[]);
  return (
    <footer data-testid="site-footer" className="bg-pipeco-dark text-white pt-20 pb-10 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{backgroundImage:"radial-gradient(circle at 20% 30%, #1A5644 0%, transparent 60%), radial-gradient(circle at 80% 70%, #164B3C 0%, transparent 60%)"}}/>
      <div className="container-x px-6 md:px-8 relative">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 pb-14 border-b border-white/10">
          <div>
            <img src="/pipeco-logo.png" alt="PIPECO GROUP" className="h-12 w-auto brightness-0 invert" data-testid="footer-logo"/>
            <div className="overline text-[10px] text-white/50 mt-3">SINCE 2010 · WATER STORAGE ENGINEERING</div>
            <p className="text-sm text-white/70 mt-5 leading-relaxed max-w-xs">Engineering water storage solutions beyond borders — manufacturing, worldwide supply, professional installation, warranty and after-sales support.</p>
            <div className="flex gap-3 mt-6">
              {[Linkedin, Facebook, Instagram, Youtube].map((Ic,i)=>(
                <a key={i} href="#" className="w-9 h-9 grid place-items-center border border-white/15 hover:bg-white hover:text-pipeco-green transition-colors" data-testid={`social-${i}`}><Ic size={15}/></a>
              ))}
            </div>
          </div>
          <div>
            <div className="overline text-[10px] text-white/50 mb-5">Solutions</div>
            <ul className="space-y-3 text-sm text-white/80">
              {[['GRP Sectional','/products/grp-sectional'],['HDG Steel','/products/hdg-steel'],['GLS / GFS','/products/gls-gfs'],['Zinc Aluminium','/products/zinc-aluminium'],['GRP Cylindrical','/products/grp-cylindrical']].map(([label, to]) => (
                <li key={label}><Link to={to} className="hover:text-white hover-line">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="overline text-[10px] text-white/50 mb-5">Company</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li><Link to="/about" className="hover-line">About</Link></li>
              <li><Link to="/manufacturing" className="hover-line">Manufacturing</Link></li>
              <li><Link to="/installation" className="hover-line">Installation</Link></li>
              <li><Link to="/projects" className="hover-line">Projects</Link></li>
              <li><Link to="/quality" className="hover-line">Quality & Certifications</Link></li>
              <li><Link to="/warranty" className="hover-line">Warranty</Link></li>
              <li><Link to="/global-presence" className="hover-line">Global Presence</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[10px] text-white/50 mb-5">Contact</div>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-white/60 shrink-0"/><a href={`tel:${settings.whatsapp_number}`} className="hover-line">{settings.whatsapp_number}</a></li>
              <li className="flex gap-3"><Mail size={16} className="mt-0.5 text-white/60 shrink-0"/><a href={`mailto:${settings.email}`} className="hover-line">{settings.email}</a></li>
              <li className="flex gap-3"><MessageCircle size={16} className="mt-0.5 text-white/60 shrink-0"/><a href={waLink(settings.whatsapp_number, quoteMessage())} target="_blank" rel="noreferrer" className="hover-line">WhatsApp Quote</a></li>
              <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-white/60 shrink-0"/><span>Global offices — see <Link to="/global-presence" className="underline hover:text-white">world map</Link></span></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} PIPECO GROUP. All rights reserved.</div>
          <div className="flex gap-6"><Link to="/global-presence" className="hover-line">Global Branches</Link>{legal.privacy&&<Link to="/privacy" className="hover-line">Privacy</Link>}{legal.terms&&<Link to="/terms" className="hover-line">Terms</Link>}</div>
        </div>
      </div>
    </footer>
  );
}
